import InlineSVG from 'svg-inline-react'
import styles from './style.styl'

const ICON_SRC = require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/icons/info-icon.svg')

const HELP_TEXT = 'Exit intent is a best-effort attempt to determine when a user is about to leave the page. Currently this condition only works on desktop browsers.'

export default () => (
  <div className={styles.ExitIntent}>
    <div is tooltip={HELP_TEXT} flow="right">
      <InlineSVG src={ICON_SRC} style={{ display: 'block' }} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/ExitIntentInput/index.js